export default __webpack_public_path__ + "static/media/app-store-badge.42ae4b16.png";